import { render, staticRenderFns } from "./NexoMemberListTable.vue?vue&type=template&id=c795fd72&"
import script from "./NexoMemberListTable.vue?vue&type=script&lang=js&"
export * from "./NexoMemberListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports